export default "__VITE_ASSET__v_23PXNu__"